import React, { useState, useEffect, useMemo } from 'react';
import { SectionTitle } from 'components/SectionTitle';
import { IArticle } from 'types';
import { useInView } from 'react-intersection-observer';
import { generateArticlesStyles } from 'sections/Articles/ArticlesStyles';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import { Card } from './Card';

export function Articles({ articles = [], title }: { articles: IArticle[], title: string }) {
    const [visibleCount, setVisibleCount] = useState(12);
    const { ref, inView } = useInView({
        threshold: 0.5,
    });
    const theme = useTheme();
    const styles = useMemo(() => generateArticlesStyles(theme), [theme]);

    useEffect(() => {
        if (inView && visibleCount < articles.length) {
            setVisibleCount((prevCount) => prevCount + 12);
        }
    }, [inView, visibleCount, articles.length]);

    return (
        <Box component="section" sx={styles.wrapper}>
            <SectionTitle title={title} sx={styles.title} />

            <Box sx={styles.cards}>
                {articles.slice(0, visibleCount).map((article) => (
                    <Card key={article.title} {...article} />
                ))}
            </Box>

            {visibleCount < articles.length && (
                <Box ref={ref}>Loading more...</Box>
            )}
        </Box>
    );
}
